// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiStepTherapy {
    static getAttributeTypeMap() {
        return MedicalBiStepTherapy.attributeTypeMap;
    }
}
MedicalBiStepTherapy.discriminator = undefined;
MedicalBiStepTherapy.additionalProperties = false;
MedicalBiStepTherapy.attributeTypeMap = [
    {
        "name": "required",
        "baseName": "required",
        "type": "boolean"
    },
    {
        "name": "treatment",
        "baseName": "treatment",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiStepTherapy.js.map